// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const fletchinder: PokeData = {
  "id": 662,
  "name": "fletchinder",
  "height": 7,
  "weight": 160,
  "base_experience": 134,
  "types": [
    PokeType.FIRE,
    PokeType.FLYING
  ],
  "api_moves": [
    "razor-wind",
    "fly",
    "tackle",
    "growl",
    "ember",
    "peck",
    "agility",
    "quick-attack",
    "flail",
    "steel-wing",
    "aerial-ace",
    "roost",
    "natural-gift",
    "feint",
    "tailwind",
    "me-first",
    "flame-charge",
    "acrobatics"
  ],
  "moves": [
    "tackle",
    "growl",
    "ember",
    "peck",
    "quick-attack",
    "aerial-ace",
    "roost",
    "tailwind",
    "acrobatics",
    "air-slash",
    "brave-bird",
    "fire-fang",
    "blaze-kick"
  ],
  "evolution_chain": {
    "id": 341,
    "item": null,
    "species": [
      {
        "name": "fletchling",
        "order": 662,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "fletchinder",
        "order": 663,
        "types": [
          PokeType.FIRE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 661,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "talonflame",
        "order": 664,
        "types": [
          PokeType.FIRE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 662,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 57.75,
    "speed": 84,
    "ability_power": 73
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
